import React from "react";
import ReactGA from "react-ga4";
import { Box, Tabs, Tab } from "@mui/material";
import { TabPanel, TabContext } from "@mui/lab";

import { EventContext } from "../../contexts/EventContext";

import Questions from "./components/questions/Questions";
import Users from "./components/users/Users";

import request from "../../utilities/requests";

const Matchmaking = () => {
  const { userData } = React.useContext(EventContext);
  const [value, setValue] = React.useState("2");
  const [questions, setQuestions] = React.useState(null);

  React.useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/matchmaking",
      title: "Matchmaking",
    });
  }, []);

  React.useEffect(() => {
    if (!questions) {
      getQuestions();
    }
  }, [questions]);

  const getQuestions = async () => {
    const result = await request("matchmaking/questions?questionsOnly=true");
    if (result.success) {
      setQuestions(result.questions);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
      <TabContext value={value}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Questions" value="1" />
          <Tab label="Users" value="2" />
        </Tabs>
        <TabPanel value="1" index={0}>
          <Questions questions={questions} refresh={getQuestions} />
        </TabPanel>
        <TabPanel value="2" index={1}>
          <Users questions={questions} />
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default Matchmaking;
